const crypto = globalThis.crypto;

export { crypto };
